import React, { Component } from 'react';
import { CDN } from 'utils';
import { theme } from 'constants';
import { Link, View, Text, MediaViewer, Image } from 'core';

const SUPPORTED_FORMAT = ['.PDF', '.DOC', '.DOCX', '.XLS', '.XLSX', '.PPT', '.PPTX', '.SVG', '.MOV', '.JPG', '.JPEG', '.PNG', '.MP4', '.GIF'];

const DOCS_FORMAT = ['.DOC', '.DOCX', '.XLS', '.XLSX', '.PPT', '.PPTX', '.SVG'];

const MEDIA_FORMAT = ['.MOV', '.JPG', '.JPEG', '.PNG', '.MP4'];

const VIDEO_FORMAT = ['.MOV', '.MP4'];

const PHOTO_FORMAT = ['.JPG', '.JPEG', '.PNG'];

const INLINE_FORMAT = ['.PDF'];

class WebBrowserProvider extends Component {
  state = {};
  componentDidMount() {
    WebBrowser = this;
  }

  async show(file) {
    const ext = file.ext.toUpperCase();
    if (SUPPORTED_FORMAT.includes(ext)) {
      const url = CDN.getURL(file, this._setUrlState);
      url && this._setUrlState(url, file);
    }
  }

  _setUrlState = async (url, file) => {
    const ext = file.ext.toUpperCase();
    if (MEDIA_FORMAT.includes(ext)) {
      PHOTO_FORMAT.includes(ext)
        ? Image.getSize(url, (width, height) => MediaViewer.show({ url, size: { width, height }, asset_type: 'PHOTO' }))
        : MediaViewer.show({ url, asset_type: 'VIDEO' });
      return;
    }

    this.setState({ show: file });
    if (DOCS_FORMAT.includes(ext)) {
      this.setState({ url });
    } else {
      const response = await fetch(url);
      const blob = await response.blob();
      const obj_url = window.URL.createObjectURL(blob);
      this.setState({ url: obj_url });
    }
  };

  close = () => {
    document.getElementById('some_frame_id').src = '';
    this.setState({ show: false, url: '', dowload: null });
  };

  async download(file) {
    this.setState({ download: await CDN.getStorageURL(file) });
  }

  async goToUrl(url) {
    const link = document.getElementById('link');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.click();
  }

  async goToTel(tel) {
    const link = document.getElementById('link');
    link.setAttribute('href', `tel:${tel}`);
    link.removeAttribute('target');
    link.click();
  }

  async goToEmail(email) {
    const link = document.getElementById('link');
    link.setAttribute('href', `mailto:${email}`);
    link.removeAttribute('target');
    link.click();
  }

  _renderDownload = link => (
    <iframe
      id="some_frame_id"
      title="Viewer"
      src={link}
      style={styles.download_iframe}
      frameBorder="0"
      allowtransparency="true"
      onLoad={e => console.log('iframeloaded')}
      onAbort={e => console.log('iframes aborted')}
      onError={e => console.log('error in loading the frame')}
    >
      <p>Your browser does not support iframes.</p>
    </iframe>
  );

  _renderView = () => {
    const { show, url } = this.state;
    const doc_viewer = `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`;
    const link = url ? (show.ext === '.pdf' ? url : doc_viewer) : '';
    //url && setTimeout(() => (document.getElementById('some_frame_id').src += ''), 100);
    return (
      <View style={styles.holder}>
        <View style={styles.header}>
          <Link
            title="refresh"
            style={styles.link}
            onPress={() => {
              document.getElementById('some_frame_id').src += '';
            }}
          />
          <Text>{show && show.name}</Text>
          <Link title="close" style={styles.link} onPress={this.close} />
        </View>
        {link ? (
          <iframe
            id="some_frame_id"
            title="Viewer"
            src={link}
            style={styles.iframe}
            frameBorder="0"
            allowtransparency="true"
            onLoad={e => console.log('iframeloaded')}
            onAbort={e => console.log('iframes aborted')}
            onError={e => console.log('error in loading the frame')}
          >
            <p>Your browser does not support iframes.</p>
          </iframe>
        ) : null}
      </View>
    );
  };

  render() {
    const { show, download } = this.state;
    return show ? this._renderView() : download ? this._renderDownload(download) : null;
  }
}

const styles = {
  header: {
    backgroundColor: '#eee',
    flexDirection: 'row',
    height: 70,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  link: {
    paddingHorizontal: 20
  },
  holder: {
    backgroundColor: theme.gray_color_alpha(0.6),
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    position: 'absolute',
    flex: 1
  },
  iframe: {
    backgroundColor: 'transparent',
    display: 'flex',
    width: '100%',
    flex: 1
  },
  download_iframe: {
    position: 'absolute',
    width: 1,
    height: 1
  }
};

let WebBrowser = {};
export { WebBrowser, WebBrowserProvider };



// WEBPACK FOOTER //
// ./src/components/core/web_browser.web.js